import { coerceArray } from '@angular/cdk/coercion';
import { TypeProjet } from '../../shared/constants/type-projet.enum';
import { FeatureDecisionService } from '../services/feature-decision/feature-decision.service';
import { BaseCondition } from './base-condition';

export class TypeProjetCondition implements BaseCondition {
  private allowedTypes: Array<TypeProjet> = [];

  constructor(allowedTypes: TypeProjet | Array<TypeProjet>) {
    this.allowedTypes = coerceArray(allowedTypes);
  }

  isAllowed(service: FeatureDecisionService): boolean {
    return this.allowedTypes.includes(service.typeProjet);
  }
}
